import { isLibrary } from './lib/useragent';

export const appDOMElementId = isLibrary ? 'winabet-app-root' : 'app';
export const portalDOMElementId = 'winabet-portal-root';

let appDOMElem: HTMLElement | null = null;
let portalDOMElem: HTMLElement | null = null;

export const getAppDOMElement = () => {
  if (!appDOMElem) {
    const originalAppDOMElement = document.getElementById(appDOMElementId);
    let newAppDOMElem = null;

    if (!originalAppDOMElement) {
      newAppDOMElem = document.createElement('div');
      newAppDOMElem.id = appDOMElementId;
      document.body.appendChild(newAppDOMElem);
    }

    appDOMElem = originalAppDOMElement || newAppDOMElem;
  }

  return appDOMElem;
};

export const getPortalRootDOMElement = () => {
  if (!portalDOMElem) {
    portalDOMElem = document.createElement('div');
    portalDOMElem.id = portalDOMElementId;

    const appDOMElement = getAppDOMElement();
    portalDOMElem = appDOMElement?.insertAdjacentElement('afterend', portalDOMElem) as HTMLElement;
  }

  return portalDOMElem;
};

export const resetDOMElements = () => {
  appDOMElem = null;
  portalDOMElem = null;
};

// safe wrapper for the querySelector method
export const querySelector = (selector: string, node: HTMLElement) => {
  try {
    if (node === undefined) {
      // when query selector is applied on document
      return document.querySelector(selector);
    } else if (node === null) {
      // when the node element doesn't exist and cannot perform the query selection
      return null;
    }
    // when node element exist perform the query selector with it
    return node.querySelector(selector);
  } catch {
    return null;
  }
};
